import template from './environment_config.html'
import controller from './environment_config.controller'
import './environment_config.scss'

const environmentConfigComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default environmentConfigComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/environment_config/environment_config.component.js